import { Modal } from '@mui/material'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import styled from 'styled-components'
import SpinnerSmall from 'components/SpinnerSmall'

export default function DestructiveConfirmModal({ open, onClose, onConfirm, loading, title, description, confirmLabel = 'Delete' }) {
  return (
    <Modal open={open} onClose={() => !loading && onClose()} aria-labelledby="destructive-confirm-title">
      <ConfirmPosition>
        <ConfirmCard>
          <ConfirmIcon><WarningAmberRoundedIcon /></ConfirmIcon>
          <h2 id="destructive-confirm-title">{title}</h2>
          <p>{description}</p>
          <ConfirmActions>
            <CancelButton type="button" disabled={loading} onClick={onClose}>Cancel</CancelButton>
            <DeleteButton type="button" disabled={loading} onClick={onConfirm}>
              {loading ? <SpinnerSmall /> : <><DeleteOutlineRoundedIcon /> {confirmLabel}</>}
            </DeleteButton>
          </ConfirmActions>
        </ConfirmCard>
      </ConfirmPosition>
    </Modal>
  )
}

const ConfirmPosition = styled.div`
  width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; padding: 18px;
`

const ConfirmCard = styled.section`
  width: min(430px, 100%); padding: 24px; border: 1px solid #e2e7e9; border-radius: 18px;
  background: #fff; color: #344145; box-shadow: 0 24px 70px rgba(16, 31, 36, .24); text-align: center;
  h2 { margin: 12px 0 7px; font-size: 18px; }
  p { margin: 0; color: #748084; font-size: 12px; line-height: 1.55; }
`

const ConfirmIcon = styled.span`
  width: 46px; height: 46px; display: grid; place-items: center; margin: 0 auto; border-radius: 13px;
  background: #fff0ee; color: #b23f35; svg { font-size: 25px; }
`

const ConfirmActions = styled.div`
  display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 20px;
`

const ConfirmButton = styled.button`
  min-height: 42px; display: flex; align-items: center; justify-content: center; gap: 7px;
  border-radius: 10px; cursor: pointer; font-size: 12px; font-weight: 750;
  &:disabled { opacity: .65; cursor: default; }
`

const CancelButton = styled(ConfirmButton)`
  border: 1px solid #d9e0e2; background: #fff; color: #4e5b5f;
  &:hover:not(:disabled) { background: #f1f4f5; }
`

const DeleteButton = styled(ConfirmButton)`
  border: 1px solid #b23f35; background: #b23f35; color: #fff;
  svg { font-size: 17px; } &:hover:not(:disabled) { background: #96332b; }
`
